module.exports = __webpack_public_path__ + "media/images/talent/feature-image02-cfba6efb1377db7253dc14d01a158ca6.png";